(() => {
  const labels = window.koflerStorefrontLabels || {};
  const selector = '.ruk_rating_snippet .ruk-rating-snippet-count';
  function shorten(element) {
    if (!element.closest('product-card')) return;
    const match = element.textContent.trim().match(/^\(\s*([\d.,]+(?:[\u00a0\u202f ]\d{3})*(?:[kKmM])?)(?:\s+[^)]*)?\s*\)$/u);
    if (!match) return;
    const text = `(${match[1]})`;
    if (element.textContent !== text) element.textContent = text;
  }
  function fixScore(element) {
    if (document.documentElement.lang.split('-')[0] !== 'it' || !labels.scoreSuffix) return;
    const number = element.querySelector('.cssVar-subheading__number');
    const score = Number(number?.textContent.trim().replace(',', '.'));
    if (!number || !Number.isFinite(score) || score < 0 || score > 5) return;
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && /^\s*(Valutazioni|su 5)\s*$/.test(node.textContent)) {
        const value = ' ' + labels.scoreSuffix;
        if (node.textContent !== value) node.textContent = value;
      }
    }
  }
  function scan(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches('.cssVar-header__subheading')) fixScore(root);
    root.querySelectorAll('.cssVar-header__subheading').forEach(fixScore);
    if (root.matches(selector)) shorten(root);
    root.querySelectorAll(selector).forEach(shorten);
  }
  scan(document.body);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') {
        const score = record.target.parentElement?.closest('.cssVar-header__subheading');
        if (score) fixScore(score);
        const count = record.target.parentElement?.closest(selector);
        if (count) shorten(count);
      } else {
        if (record.target.matches?.('.cssVar-header__subheading')) fixScore(record.target);
        if (record.target.matches?.(selector)) shorten(record.target);
        record.addedNodes.forEach(scan);
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
